module.exports = __webpack_public_path__ + "static/media/shuzihuaguanli.902d4fc3.png";